import React from 'react'
import { AppBar, Toolbar, Typography } from '@material-ui/core'
import { useStyles } from '../styles'

function NavigationBar() {

  const classes = useStyles()

  return (
    <>
      <AppBar position='fixed'>
        <Toolbar>
          <Typography variant='h6' className={classes.title}>
            Facebook Simulation
          </Typography>
        </Toolbar>
      </AppBar>
      <div style={{ height: '80px' }}></div>
    </>
  )
}

export default NavigationBar
